import { register } from '../../api/register';
import { IframeWindow } from '.';

export class Register implements register.Api {
  constructor(private iframe: IframeWindow) {}

  reloadDocumentRegisterList(request: register.ReloadDocumentRegisterListRequest): void {
    this.iframe.postMessage({
      command: 'register.reloadDocumentRegisterList',
      args: request,
    });
  }
  reloadPowerEstateList(request: register.ReloadPowerEstateListRequest): void {
    this.iframe.postMessage({
      command: 'register.reloadPowerEstateList',
      args: request,
    });
  }
}
